export const GET_MEMBER_INSURANCE_INFO = 'GET_MEMBER_INSURANCE_INFO';
export const GET_MEMBER_INSURANCE_INFO_SUCCESS = `${GET_MEMBER_INSURANCE_INFO}_SUCCESS`;
